export default "__VITE_ASSET__tXHbN2Ms__"